if(!customElements.get("product-grid-card")) {
  customElements.define("product-grid-card", class ProductGridCard extends HTMLElement {
    constructor() {
      super();

      this.quickbuyMenuBtn = this.querySelector(".product__mobile-btn.prod-quickbuy");
      this.desktopQuickbuyBtns = this.querySelectorAll(".quickshop-btns .quickshop-btn");
      this.mobileQuickbuyBtns = this.querySelectorAll(".product__mobile-btn.quickbuy");
      this.sideCart = document.querySelector("side-cart");

      this.mobileQuickBuyBtn = this.querySelector(".mobile-quick-add__button");
      this.quickShopMenu = this.querySelector(".quickshop-menu");

      this.mobileQuickBuyBtn.addEventListener("click", this.showMobileQuickBuy.bind(this));

      this.init();
    }

    init() {
      if(this.quickbuyMenuBtn) this.quickbuyMenuBtn.addEventListener("click", this.quickbuyMenuToggle.bind(this));
      this.desktopQuickbuyBtns.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          // this.quickAddToCart(event, btn);
          this.sideCart.handleAddItem(event, btn);
        });
      });
      this.mobileQuickbuyBtns.forEach(btn => {
        btn.addEventListener("click", (event) => {
          // this.quickAddToCart(event, btn)
          this.sideCart.handleAddItem(event, btn);
        });
      });
    }

    showMobileQuickBuy(e){
      e.preventDefault();
      const isPressed = this.mobileQuickBuyBtn.getAttribute("aria-pressed");

      if(isPressed === "false") {
        this.mobileQuickBuyBtn.setAttribute("aria-pressed", "true")
        this.quickShopMenu.classList.toggle("open");
        return
      }
      
      this.mobileQuickBuyBtn.setAttribute("aria-pressed", "false");
    }

    quickbuyMenuToggle() {
      this.quickbuyMenuBtn.classList.toggle("quickbuy-menu-open");
    }

    quickAddToCart(event, quickbuyBtn) {
      console.log("event target", event.target);
      console.log("event target", quickbuyBtn);
    }
  });
}
